import * as React from 'react';
import CountryService from '../../services/CountryService';
import Image from '../../components/Image';
import { getImageFromProductByVariant } from '../../helpers/getImageFromProductByVariant';

interface ICartModalProps {
  closeModal: () => void;
  unavailableProducts: any[];
  goToPersonData: () => void;
}

class CartModalUnavailableProducts extends React.Component<ICartModalProps> {

  public redirect = () => {
    return this.props.goToPersonData();
  }
  
  public render() {
    const { language } = CountryService.GetInstance();
    const {closeModal, unavailableProducts} = this.props;

    return (
      <div className="cart-modal-wrapper">
        <div className="cart-modal">
          <h3>WE ARE SORRY!</h3>
          <p>
            Some of the selected items are unfortunately out of stock or on backorder.<br/>
            It might take us some time to re-stock and ship these item(s).<br/>
            Please select below how would you like to proceed.
          </p>
          <div className="products-row">
            {unavailableProducts && Array.isArray(unavailableProducts) &&
              unavailableProducts.map((product: any) => {
                const image = getImageFromProductByVariant(product.product, product);
                return (<div className="product-thumb" key={product.id}>
                  <Image image={image} width={120} height={120} alt="" />
                  <p className="product-name">{product.product.name[language]}</p>
                </div>);
              })
            }
          </div>
          <div className="row">
            <div className="col-md-5">
              <button className="btn btn--return btn--fullMd" onClick={() => closeModal()}>
                I can’t wait for restock.<br/>
                I wish to change my order.
              </button>
            </div>
            <div className="col-md-7">
              <button className="btn btn--proceed btn--fullMd" onClick={() => this.redirect()}>
                 I’d like to complete my order now and wait until everything is ready to be shipped together.
              </button>
            </div>
          </div>
          {/* <button onClick={() => closeModal()} >close modal</button> */}
        </div>
      </div>
    );
  }
}

export default CartModalUnavailableProducts;



// WEBPACK FOOTER //
// ./src/modules/CartModalUnavailableProducts/CartModalUnavailableProducts.tsx